import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Management

const Users = Loader(lazy(() => import('src/content/management/Users')));
const SingleUser = Loader(
  lazy(() => import('src/content/management/Users/single'))
);
const Orders = Loader(lazy(() => import('src/content/management/Orders')));
const Calendar = Loader(lazy(() => import('src/content/management/Calendar')));
const SingleOrder = Loader(
  lazy(() => import('src/content/management/Orders/single'))
);
const Invoices = Loader(lazy(() => import('src/content/management/Invoices')));
const SingleInvoice = Loader(
  lazy(() => import('src/content/management/Invoices/single'))
);
const Products = Loader(lazy(() => import('src/content/management/Products')));
const CreateProduct = Loader(
  lazy(() => import('src/content/management/Products/create'))
);
const SingleProduct = Loader(
  lazy(() => import('src/content/management/Products/single'))
);
const Shop = Loader(lazy(() => import('src/content/management/Products/shop')));
const Employees = Loader(
  lazy(() => import('src/content/management/Employees'))
);
const Earnings = Loader(
  lazy(() => import('src/content/management/Earnings'))
);
const PayoutDetails = Loader(
  lazy(() => import('src/content/management/Earnings/PayoutDetails'))
);
const PaymentMethods = Loader(
  lazy(() => import('src/content/management/PaymentMethods'))
);
const AddPaymentMethod = Loader(
  lazy(() => import('src/content/management/PaymentMethods/Add'))
);

const managementRoutes = [
  {
    path: '',
    element: <Navigate to="orders" replace />
  },
  {
    path: 'users',
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />
      },
      {
        path: 'list',
        element: <Users />
      },
      {
        path: 'single',
        children: [
          {
            path: '',
            element: <Navigate to="1" replace />
          },
          {
            path: ':userId',
            element: <SingleUser />
          }
        ]
      }
    ]
  },
  {
    path: 'orders',
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />
      },
      {
        path: 'list',
        element: <Orders />
      },
      {
        path: 'single',
        children: [
          {
            path: '',
            element: <Navigate to="1" replace />
          },
          {
            path: ':compositeOrderId',
            element: <SingleOrder />
          }
        ]
      }
    ]
  },
  {
    path: 'calendar',
    children: [
      {
        path: '',
        element:  <Calendar />
      }
    ]
  },
  {
    path: 'employees',
    element: <Employees />
  },
  {
    path: 'earnings',
    children: [
      {
        path: '',
        element: <Earnings />
      },
      {
        path: 'payouts',
        children: [
          {
            path: ':payoutId',
            element: <PayoutDetails />
          }
        ]
      }
    ]
  },
  {
    path: 'payment-methods',
    children: [
      {
        path: '',
        element: <PaymentMethods />
      },
      {
        path: 'add',
        element: <AddPaymentMethod />
      }
    ]
  },
  {
    path: 'commerce',
    children: [
      {
        path: '',
        element: <Navigate to="shop" replace />
      },
      {
        path: 'shop',
        element: <Shop />
      },
      {
        path: 'products',
        children: [
          {
            path: '',
            element: <Navigate to="list" replace />
          },
          {
            path: 'list',
            element: <Products />
          },
          {
            path: 'create',
            element: <CreateProduct />
          },
          {
            path: 'single',
            children: [
              {
                path: '',
                element: <Navigate to="1" replace />
              },
              {
                path: ':productId',
                element: <SingleProduct />
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: 'invoices',
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />
      },
      {
        path: 'list',
        element: <Invoices />
      },
      {
        path: 'single',
        children: [
          {
            path: '',
            element: <Navigate to="1" replace />
          },
          {
            path: ':invoiceId',
            element: <SingleInvoice />
          }
        ]
      }
    ]
  }
];

export default managementRoutes;
